import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=a437374e"
import script from "./Test.vue?vue&type=script&lang=ts"
export * from "./Test.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/views/_locales/Administration.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Ftest%2FTest.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports